import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2-al': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_f_tai_chi_walking_v2_al_bmi_post_funnel~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-al-bmi-post',
				locale: ['en'],
			},
		},
	},
]

export default config
